import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide", "dot", "prevButton", "nextButton"]
  static values = { dismissUrl: String }

  connect() {
    if (this.slideTargets.length === 0) return

    this.currentIndex = 0
    this.viewedIds = new Set()

    // Mark first slide as viewed
    this.viewedIds.add(this.slideTargets[0].dataset.announcementId)

    this.updateUI()

    // Lock body scroll
    document.body.classList.add("overflow-hidden")

    // Bind keyboard listener
    this._handleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("keydown", this._handleKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this._handleKeydown)
    document.body.classList.remove("overflow-hidden")
  }

  next() {
    if (this.currentIndex >= this.slideTargets.length - 1) return
    this.currentIndex++
    this.viewedIds.add(this.slideTargets[this.currentIndex].dataset.announcementId)
    this.updateUI()
  }

  previous() {
    if (this.currentIndex <= 0) return
    this.currentIndex--
    this.viewedIds.add(this.slideTargets[this.currentIndex].dataset.announcementId)
    this.updateUI()
  }

  close() {
    // Fire-and-forget dismissal
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
    fetch(this.dismissUrlValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken
      },
      body: JSON.stringify({ announcement_ids: Array.from(this.viewedIds) })
    })

    // Remove modal
    document.body.classList.remove("overflow-hidden")
    this.element.remove()
  }

  handleKeydown(event) {
    switch (event.key) {
      case "Escape":
        this.close()
        break
      case "ArrowLeft":
        this.previous()
        break
      case "ArrowRight":
        this.next()
        break
    }
  }

  updateUI() {
    // Toggle slide visibility
    this.slideTargets.forEach((slide, index) => {
      slide.classList.toggle("hidden", index !== this.currentIndex)
    })

    // Update dots
    if (this.hasDotTarget) {
      this.dotTargets.forEach((dot, index) => {
        if (index === this.currentIndex) {
          dot.classList.remove("bg-white/50")
          dot.classList.add("bg-white")
        } else {
          dot.classList.remove("bg-white")
          dot.classList.add("bg-white/50")
        }
      })
    }

    // Update arrow visibility
    if (this.hasPrevButtonTarget) {
      this.prevButtonTarget.classList.toggle("invisible", this.currentIndex === 0)
    }
    if (this.hasNextButtonTarget) {
      this.nextButtonTarget.classList.toggle("invisible", this.currentIndex === this.slideTargets.length - 1)
    }
  }
}
